import { Component, OnInit, OnDestroy,Inject  } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { BillingService } from '../../../../services/billing.service';

import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DownloadOthInvoices } from '../../../../models/invoices-reports.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'dialog-other-government-export-transaction',
    templateUrl: 'dialog.exporttransaction.html',
    styleUrls: ['dialog.exporttransaction.css']
})

export class ExportOtherGovernmentTransactionDialog  implements OnInit, OnDestroy {
  othinvoicesreportform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  downloadOthInvoices: DownloadOthInvoices = new DownloadOthInvoices();
  accountOffices = [];
  airAsiaAccounts = [];
  fileType = [
    { value: '.pdf', viewValue: 'PDF File' },
    { value: '.xls', viewValue: 'Excel File' }
  ];

  constructor(public dialogRef: MatDialogRef<ExportOtherGovernmentTransactionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private billingService: BillingService,
    private reportService: ReportService,
    private userService: UserService,
    public snackBar: MatSnackBar) { 
      let user = this.userService.getUser();
      this.userName = user.username;
      this.screenCode = user.screenCode;
    }


  ngOnInit() {
    this.othinvoicesreportform = new FormGroup({
      invDate: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      axaptaNo: new FormControl({ value: '', disabled: false }),
      warrantNo: new FormControl({ value: '', disabled: false }, [Validators.required]),
      accountOffice: new FormControl({ value: '', disabled: false }, [Validators.required]),
      airAsiaAccount: new FormControl({ value: '', disabled: false }, [Validators.required]),
      bookingDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      bookingDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      eportedFileType: new FormControl({ value: '', disabled: false })
    });
    this.loading = true;

    let initial_sub = this.reportService.getInitOthInvoices()
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.accountOffices = data.body['accountOffices'];

            this.othinvoicesreportform.setValue({
              invDate: this.othinvoicesreportform.get('invDate')!.value,
              axaptaNo: this.othinvoicesreportform.get('axaptaNo')!.value,
              warrantNo: this.othinvoicesreportform.get('warrantNo')!.value,
              accountOffice: this.othinvoicesreportform.get('accountOffice')!.value,
              airAsiaAccount: this.othinvoicesreportform.get('airAsiaAccount')!.value,
              bookingDateFrom: this.othinvoicesreportform.get('bookingDateFrom')!.value,
              bookingDateTo: this.othinvoicesreportform.get('bookingDateTo')!.value,
              eportedFileType: this.fileType[0].value
            });
          } else {
            this.openSnackBar('Error loading agency and account office.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(initial_sub);
  }

  selectedAccOff(selectedValue) {
    this.loading = true;

    let account_sub = this.reportService.getAaAccounts(selectedValue)
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {
          } else if (data.status === 200) {
            this.airAsiaAccounts = data.body['aaAccounts'];
          } else {
            this.openSnackBar('Error retrieve AA Account.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(account_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    this.downloadOthInvoices.AccountNo = form.get('axaptaNo').value;
    this.downloadOthInvoices.AccountOfficeCode = form.get('accountOffice').value;
    this.downloadOthInvoices.BookingDateFrom = form.get('bookingDateFrom').value;
    this.downloadOthInvoices.BookingDateTo = form.get('bookingDateTo').value;
    this.downloadOthInvoices.InvoiceDate = form.get('invDate').value;
    this.downloadOthInvoices.AaAccount = form.get('airAsiaAccount').value;
    this.downloadOthInvoices.WarrantNo = form.get('warrantNo').value;
    this.downloadOthInvoices.ExportFileType = this.fileType[0].value;

    let update_sub = this.billingService.downloadOtherGovBilling(this.downloadOthInvoices)
      .subscribe(
        (value) => {
          if (value.status === 204) {

          } else if (value.status === 200) {
            if (this.downloadOthInvoices.ExportFileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'OTH Invoice.xls');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            } else if (this.downloadOthInvoices.ExportFileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'OTH Invoice.pdf');
              this.isSubmit = false;
              this.downloadMessage = '';
              this.openSnackBar('Invoice Created.', '');
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Error downloading invoice.', '');
          }
        },
        (error) => {
          this.isSubmit = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(update_sub);
  }

  closeDialog(): void {
    this.dialogRef.close('Close');
}


  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
